import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { EntryType, Menu, MenuEntry } from "../core/components/menu";
import { IsNumericTextBox, NumericTextBoxProps } from "../core/components/isNumericTextBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { FieldInstance } from "../core/components/field";
import { IsSearchField } from "../core/components/isSearchField"
import { WidthProperty } from "../statistics/property_types";
import { Button } from "../core/components/button";
import { DialogHelper } from "../core/util/dialogHelper";
import { TextBox } from "../core/components/textBox";
import { IsPanelbarDetails } from "../core/components/isPanelbarDetails";
import { AppHelper } from "../appHelper";
import { Config } from "../core/config/config";
import { DocumentPreview } from "../documents/documents"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import React from "react";
export interface MonatsAbrechnungsInGridProps extends AppBaseProps {
    onRowClicked?: (dataItem: MonatsAbrechnungEintrag) => void;
}
export default class MonatsAbrechnungInGrid extends React.Component<MonatsAbrechnungsInGridProps, {
    gridData: MonatsAbrechnungEintrag[],
    yearFilter: number,
    monthFilter: number,
    ressFilter: string,
    fileInfo: MonatsAbrechnungFileInfo,
    typZuordnung: MonatsAbrechnungTypLookup[],
    vormonatUeberstunden: number,
    vormonatUeberstundenAusbezahlt: number,
}>{
    private factory = ComponentHelper.createFactory();
    common = new AppHelper();
    private gridOptions = {};
    private schema = {
        "Id": "PseudoID",
        "fields": {

        }
    };
    editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.common.init(this);
        this.state = {
            gridData: [],
            yearFilter: new Date().getFullYear(),
            monthFilter: new Date().getMonth() + 1,
            ressFilter: "",
            fileInfo: null,
            typZuordnung: [],
            vormonatUeberstunden: 0,
            vormonatUeberstundenAusbezahlt: 0,


        };
        this.gridOptions = {
            "columns": [
                {
                    "type": "textBox",
                    "field": "PseudoID",
                    "title": "PseudoID",
                    "width": 150,
                    "required": true,
                    "readOnly": true,
                    "visible": false
                },
                {
                    "type": "textBox",
                    "field": "Ressnr",
                    "title": "Ressnr",
                    "width": 150,
                    "required": true,
                    "readOnly": true,
                    "visible": false
                },
                {
                    "type": "textBox",
                    "field": "Jahr",
                    "title": "Jahr",
                    "width": 150,
                    "required": true,
                    "readOnly": true,
                    "visible": false
                },
                {
                    "type": "textBox",
                    "field": "Monat",
                    "title": "Monat",
                    "width": 150,
                    "required": true,
                    "visible": false
                },
                {
                    "type": "datePicker",
                    "field": "Cmtp_Datum",
                    "title": "Datum",
                    "width": 100,
                    "required": true,
                    "readonly": true

                },
                {
                    "type": "textBox",
                    "field": "Tag",
                    "title": "Tag",
                    "width": 60,
                    "readonly": true,
                    "template": "#=kendo.toString(row.Cmtp_Datum, 'ddd')#"
                },
                {
                    "type": "checkbox",
                    "field": "IstArbeitszeit",
                    "title": "IstArbeitszeit",
                    "width": 60,
                    "readonly": true,
                    "visible": false
                },
                {
                    "type": "textBox",
                    "field": "Faktor",
                    "title": "Faktor",
                    "width": 60,
                    "readonly": true,
                    "visible": false
                },
                {
                    "type": "dropdown",
                    "field": "Cmtp_Typ",
                    "title": "Typ",
                    "dataSourceURL": "NovofermMonatsAbrechnung/GetTyp",
                    "dataTextField": "Typname",
                    "dataValueField": "Id",
                    "width": 100,
                    "required": "row.Sollstunden > 0"
                },
                {
                    "field": "Cmtp_Beginn",
                    "title": "Beginn",
                    "type": "timeTextBox",
                    "template": "#= ((Cmtp_Beginn == 0) && (Cmtp_Ende == 0 || Cmtp_Ende == null) ) || Cmtp_Beginn == null ? '--:--' : Innosoft.Core.Utils.Helper.dates.getMinToHHMM(Cmtp_Beginn) #",
                    "width": 81,
                    "required": false

                },
                {
                    "type": "timeTextBox",
                    "field": "Cmtp_Ende",
                    "title": "Ende",
                    "template": "#= ((Cmtp_Beginn == 0 || Cmtp_Beginn == null) && (Cmtp_Ende == 0) ) || Cmtp_Ende == null  ? '--:--' : Innosoft.Core.Utils.Helper.dates.getMinToHHMM(Cmtp_Ende) #",
                    "width": 81,
                    "required": false

                },
                {
                    "type": "numericTextBox",
                    "field": "Cmtp_PauseMinuten",
                    "title": "PauseMinuten",
                    "format": "{0:n2}",
                    "template": "#= (Cmtp_PauseMinuten && IstArbeitszeit) ? Cmtp_PauseMinuten : ''#",
                    "width": 150,
                    "min": 0,
                    "required": false,
                    "readonly": "!row.IstArbeitszeit"

                },
                {
                    "type": "numericTextBox",
                    "field": "Cmtp_Sonderfall",
                    "title": "Sonderfall",
                    "template":"#=(Cmtp_Sonderfall && IstArbeitszeit) ? Cmtp_Sonderfall : ''#",
                    "min": 0,
                    "width": 100,
                    "required": false,
                    "readonly": "!row.IstArbeitszeit"
                },
                {
                    "type": "multiColumn",
                    "title": "Verstöße",
                    "width": 200,
                    "columns": [
                        {
                            "type": "checkbox",
                            "field": "Cmtp_10H",
                            "title": "10 Std.",
                            "template": "# if(Cmtp_10H) {# <div style='background-color: red; color:white; padding: 2px'><i class='fal fa-circle-exclamation fa-2x'></i><span></span></div> #}else{#<div><span>-</span></div>#}#",
                            "width": 100,
                            "required": false,
                            "readonly": true
                        },
                        {
                            "type": "checkbox",
                            "field": "Cmtp_Ruhezeit",
                            "title": "Ruhezeit",
                            "template": "# if(Cmtp_Ruhezeit) {# <div style='background-color: red; color:white; padding: 2px'><i class='fal fa-circle-exclamation fa-2x'></i><span></span></div> #}else{#<div><span>-</span></div>#}#",
                            "width": 100,
                            "required": false,
                            "readonly": "!row.IstArbeitszeit"
                            
                        }]
                },

                {
                    "type": "textBox",
                    "field": "Cmtp_Kommentar",
                    "title": "Kommentar",
                    "multiLine": true,
                    "width": 250,
                    "required": false
                },
                {
                    "type": "numericTextBox",
                    "field": "Iststunden",
                    "title": "Iststunden",
                    "format": "{0:n2}",
                    "template": "# if(IstArbeitszeit && Iststunden < 0) {# <div style='background-color: yellow'>#=kendo.toString(Iststunden ?? 0, 'n2')#</div>#}else{#<div>#=kendo.toString(Iststunden ?? 0, 'n2')#</div>#}#",
                    "readonly": true,
                    "width": 100,
                    "required": false
                },
                {
                    "type": "numericTextBox",
                    "field": "Sollstunden",
                    "title": "Sollstunden",
                    "format": "{0:n2}",
                    "min": 0,
                    "max": 24,
                    "width": 100,
                    "required": false
                }

            ]

        };
    }

    componentDidMount() {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.setTitle("Monatsabrechnung")
        this.getTypLookup();
    }


    private loadData = async () => {
        const datasource = this.editableGridRef.getDataSource();
        if (datasource) {
            let changedItems: MonatsAbrechnungEintrag[] = datasource["updated"]();
            if (changedItems.length > 0) {
                const isOk = await DialogHelper.confirm("Es gibt ungespeicherte Änderungen, die beim laden neuer Daten verloren gehen. Fortfahren?");
                if (!isOk) {
                    return;
                }
            }
        }

        let urlGrid = `NovofermMonatsAbrechnung/GetGridData?year=${encodeURIComponent(this.state.yearFilter)}&month=${encodeURIComponent(this.state.monthFilter)}&ressnr=${encodeURIComponent(this.state.ressFilter)}`
        const resultGrid = await HTTPService.get<JsonResultClass<MonatsAbrechnungEintrag[]>>(urlGrid);
        if (resultGrid.Code == 0) {
            this.setState({ gridData: resultGrid.Data });
        } else {
            NotificationHelper.showErrorMessage(resultGrid.Message);
        }
        let urlDoku = `NovofermMonatsAbrechnung/GetFileInfo?year=${encodeURIComponent(this.state.yearFilter)}&month=${encodeURIComponent(this.state.monthFilter)}&ressnr=${encodeURIComponent(this.state.ressFilter)}`
        const resultDoku = await HTTPService.get<JsonResultClass<MonatsAbrechnungFileInfo>>(urlDoku);
        if (resultDoku.Code == 0) {
            this.setState({ fileInfo: resultDoku.Data })
        }
        let urlVormonat = `NovofermMonatsAbrechnung/GetVormonatInfo?year=${encodeURIComponent(this.state.yearFilter)}&month=${encodeURIComponent(this.state.monthFilter)}&ressnr=${encodeURIComponent(this.state.ressFilter)}`
        const vormonatResult = await HTTPService.get<JsonResultClass<VormonatsInfo>>(urlVormonat);
        if (vormonatResult.Code == 0) {
            this.setState({ vormonatUeberstunden: vormonatResult.Data.Ueberstunden_Vormonat, vormonatUeberstundenAusbezahlt: vormonatResult.Data.Ueberstunden_Vormonat_Ausgezahlt })
        }
        this.common.setEntityDirtyState(false);

    }
    private setPrint = async () => {
        let url = `NovofermMonatsAbrechnung/SetPrint?year=${encodeURIComponent(this.state.yearFilter)}&month=${encodeURIComponent(this.state.monthFilter)}&ressnr=${encodeURIComponent(this.state.ressFilter)}`
        const result = await HTTPService.post<JsonResultClass<MonatsAbrechnungEintrag[]>>(url);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    public getTypLookup = async () => {
        let urlDoku = `NovofermMonatsAbrechnung/GetTyp`
        const resultTyp = await HTTPService.get<MonatsAbrechnungTypLookup[]>(urlDoku);
        if (resultTyp.length > 0) {
            this.setState({ typZuordnung: resultTyp })
        }
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }
    public save = async () => {
        const dataSource = this.editableGridRef.getDataSource();
        const changed: MonatsAbrechnungEintrag[] = dataSource["updated"]();
        const url = 'NovofermMonatsAbrechnung/Save';
        const toSend = {
            EntryToUpdate: changed.map((i) => {
                return {
                    PseudoID: i["PseudoID"], Ressnr: i["Ressnr"], Jahr: i["Jahr"], Monat: i["Monat"], Cmtp_Datum: i["Cmtp_Datum"], Cmtp_Typ: i["Cmtp_Typ"], IstArbeitszeit: i["IstArbeitszeit"],
                    Cmtp_Beginn: i["Cmtp_Beginn"], Cmtp_Ende: i["Cmtp_Ende"], Cmtp_PauseMinuten: i["Cmtp_PauseMinuten"], Cmtp_Sonderfall: i["Cmtp_Sonderfall"], Cmtp_10H: i["Cmtp_10H"],
                    Cmtp_Ruhezeit: i["Cmtp_Ruhezeit"], Cmtp_Kommentar: i["Cmtp_Kommentar"], Sollstunden: i["Sollstunden"], Faktor: i["Faktor"]
                }
            }),
        };
        const result = await HTTPService.post(url, toSend);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.setEntityDirtyState(false);
        this.editableGridRef.getDataSource().sync();
    }
    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: MonatsAbrechnungEintrag[]) => {
        if (!this.flag) {
            this.flag = true;
            if (action == "itemchange") {
                if (fieldName == "Cmtp_Beginn") {
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "Cmtp_Beginn");
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "Cmtp_Ende");
                }

                if (fieldName == "Cmtp_Ende") {
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "Cmtp_Beginn");
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "Cmtp_Ende");
                }
                let index = this.state.gridData.findIndex(x => x.Cmtp_Datum == dataItems[0].Cmtp_Datum);
                let newGridData = this.state.gridData;
                newGridData[index] = dataItems[0];
                if (fieldName == "Cmtp_Typ") {
                    if (newGridData[index].Cmtp_Typ) {
                        let newTyp = this.state.typZuordnung.find(x => x.Id == dataItems[0].Cmtp_Typ);
                        newGridData[index].IstArbeitszeit = newTyp.Arbeitszeit;
                        newGridData[index].Faktor = newTyp.Faktor;
                        if (!newGridData[index].IstArbeitszeit) {
                            newGridData[index].Cmtp_PauseMinuten = 0;
                            newGridData[index].Cmtp_Sonderfall = 0;
                            newGridData[index].Cmtp_Ruhezeit = false;
                            this.editableGridRef.refreshColumnTemplate(newGridData[index], "Cmtp_PauseMinuten");
                            this.editableGridRef.refreshColumnTemplate(newGridData[index], "Cmtp_Sonderfall");
                            this.editableGridRef.refreshColumnTemplate(newGridData[index], "Cmtp_Ruhezeit");
                        }
                    }

                }
                const typ = this.state.typZuordnung.find(typ => typ.Id == dataItems[0].Cmtp_Typ);
                const faktor = typ ? typ.Faktor : 1.0;
                newGridData[index].Faktor = faktor;
                newGridData[index].Iststunden = newGridData[index].IstArbeitszeit ? (newGridData[index].Cmtp_Ende - newGridData[index].Cmtp_Beginn - (newGridData[index].Cmtp_PauseMinuten ?? 0) + ((newGridData[index].Cmtp_Sonderfall ?? 0) * 60)) * faktor / 60.0 : newGridData[index].Sollstunden * faktor;
                if (newGridData[index].Iststunden > 10) {
                    newGridData[index].Cmtp_10H = true;
                }
                else {
                    newGridData[index].Cmtp_10H = false;
                }
                this.editableGridRef.refreshColumnTemplate(newGridData[index], "Cmtp_10H");
                this.editableGridRef.refreshColumnTemplate(newGridData[index], "Iststunden");

                this.setState({ gridData: newGridData });
                this.flag = false;
                this.common.setEntityDirtyState(true);
            }
        }


    }
    handleShowDocumentClick = () => {
        const sheet = General.Sheet.Manager.createSheet();
        if (Helper.hasValue(this.state.fileInfo)) {
            const props: any = { filename: this.state.fileInfo.Filename, dokuGuid: this.state.fileInfo.Guid };
            sheet.setTitle(Helper.getTranslation("Standard.Preview"));
            sheet.show(() => {
                sheet.mountContent(DocumentPreview, props);
            });
        }

    }

    private createFilter = () => {
        let yearFilterProps = this.factory.getDefaultNumericTextBoxProps();
        yearFilterProps.value = this.state.yearFilter;
        yearFilterProps.field.min = 0;
        yearFilterProps.onChange = (field, value: number) => {
            this.setState({ yearFilter: value, fileInfo: null });
        }
        let monthFilterProps = this.factory.getDefaultNumericTextBoxProps();
        monthFilterProps.value = this.state.monthFilter;
        monthFilterProps.field.min = 1;
        monthFilterProps.field.max = 12;
        monthFilterProps.onChange = (field, value: number) => {
            this.setState({ monthFilter: value, fileInfo: null });
        }
        let ressSearchProps = this.factory.getDefaultSearchFieldProps();
        ressSearchProps.field.autocompleteEnabled = true;
        ressSearchProps.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 80px' /><col style='width: 100px' /><col style='width: 100px' /></colgroup><tr style='background-color:# if(data.StatusAsInt == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.Ressnr}</td><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top'>#=data.Vorname != null ? data.Vorname : ''#</td></tr></table>";
        ressSearchProps.field.autocompleteUrl = "ResourceLookup/FindWithId";
        ressSearchProps.field.searchWindowUrl = "DynamicSearch/Window/Resource";
        ressSearchProps.field.dataTextField = "Ressnr";
        ressSearchProps.field.title = "Ressource";
        ressSearchProps.field.autocompleteDataTextField = "Ressnr";
        ressSearchProps.value = this.state.ressFilter;
        ressSearchProps.onChange = (field, value: string) => {
            this.setState({ ressFilter: value, fileInfo: null });
            General.Drawer.Left.disable();
        };
        let ispdProps = ComponentHelper.createFactory().getDefaultPanelbarDetailsProps();
        ispdProps.field.url = "ResourceLookup/ResourceHeader";
        ispdProps.field.template = "ResourceDetails";
        ispdProps.onDataLoaded = () => { };
        ispdProps.value = this.state.ressFilter;
        let filtersEmpty = this.state.monthFilter == null || this.state.yearFilter == null || this.state.ressFilter == null || this.state.ressFilter == "";
        let buttonStyle: React.CSSProperties = {
            width: '150px',
            height: '39px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'black',
            borderRadius: '0.375rem',
            backgroundColor: 'white',
            position: 'relative',
            left: '5px',
            marginBottom: '5px',
            cursor: 'pointer',
        };
        return (
            <div style={{ display: "flex" }}>
                <div style={{ width: "200px" }}>
                    <FieldInstance label={"Jahr"} >
                        <IsNumericTextBox {...yearFilterProps} />
                    </FieldInstance>
                </div>
                <div style={{ width: "200px" }}>
                    <FieldInstance label={"Monat"} >
                        <IsNumericTextBox {...monthFilterProps} />
                    </FieldInstance>
                </div>
                <div style={{ width: "300px" }}>
                    <FieldInstance label={"Ressource"}>
                        <IsSearchField field={ressSearchProps.field} value={ressSearchProps.value} context={ressSearchProps.context} commandManager={null}
                            onChange={ressSearchProps.onChange} handleEval={ressSearchProps.handleEval} handleIsSearchFieldFullObjectModel={ressSearchProps.handleIsSearchFieldFullObjectModel}
                            multiSelectMode={false} disabled={false} />
                    </FieldInstance>
                </div>
                <div style={{ marginTop: "5px", zIndex: 2 }}>
                    <IsPanelbarDetails {...ispdProps} />
                </div>
                <div style={{ marginRight: 0, marginLeft: "auto", display: "flex", rowGap: "5px", textAlignLast: "right", height: "50px" }}>
                    <div>

                        <button
                            style={{ marginLeft: "5px", marginTop: "5px", height: "70%" }}
                            className={"innoOptionsButton"}
                            title={"Daten laden"}
                            onClick={this.loadData}
                            disabled={filtersEmpty}
                        >Daten laden</button>
                    </div>
                    <div>

                        <button
                            style={{ marginLeft: "5px", marginTop: "5px", height: "70%" }}
                            className={"innoOptionsButton"}
                            title={"Drucken"}
                            onClick={this.setPrint}
                            disabled={filtersEmpty}
                        >Drucken</button>
                    </div>
                    <div>

                        <button
                            style={{ marginLeft: "5px", marginTop: "5px", height: "70%" }}
                            className={"innoOptionsButton"}
                            title={"Dokument öffnen"}
                            onClick={this.handleShowDocumentClick}
                            disabled={this.state.fileInfo == null || this.state.fileInfo.Guid == ""}
                        >Dokument öffnen</button>
                    </div>
                </div>


            </div>
        );
    }

    private _renderVormonat = () => {
        let vormonatUeberstundenProps = this._getNumericTextBoxProps();
        let vormonatUeberstundenAusgezahltProps = this._getNumericTextBoxProps();
        vormonatUeberstundenProps.value = this.state.vormonatUeberstunden;
        vormonatUeberstundenAusgezahltProps.value = this.state.vormonatUeberstundenAusbezahlt;

        return <>
            <div style={{ display: "flex" }}>
                <div style={{ alignContent: "center" }}>Überstunden Vormonat</div>
                <FieldInstance noLabel={true} label="Überstunden Vormonat" noHover={true}>
                    <IsNumericTextBox {...vormonatUeberstundenProps} />
                </FieldInstance>
                <div style={{ alignContent: "center" }}>Überstunden Vormonat ausgezahlt</div>
                <FieldInstance noLabel={true} label="Überstunden Vormonat ausgezahlt" noHover={true}>
                    <IsNumericTextBox  {...vormonatUeberstundenAusgezahltProps} />
                </FieldInstance>
            </div>


        </>
    }

    private _getNumericTextBoxProps(): NumericTextBoxProps {
        let newTextboxProps = this.factory.getDefaultNumericTextBoxProps();
        newTextboxProps.disabled = true;
        newTextboxProps.field.decimals = 2;
        newTextboxProps.field.format = "0.00";
        newTextboxProps.field.spinners = false;
        return newTextboxProps;
    }

    private _renderTotals = () => {
        let istProps = this._getNumericTextBoxProps();
        let sollProps = this._getNumericTextBoxProps();
        let monatUeberProps = this._getNumericTextBoxProps();
        let gesUeberProps = this._getNumericTextBoxProps();
        let gesIststunden = this.state.gridData.reduce((n, { Iststunden }) => Iststunden ? n + Iststunden : n, 0);
        let gesSollstunden = this.state.gridData.reduce((n2, { Sollstunden }) => Sollstunden ? n2 + Sollstunden : n2, 0);
        let iststundenRounded = Math.round(gesIststunden * 100) / 100
        let sollstundenRounded = Math.round(gesSollstunden * 100) / 100
        let ueberstundenRounded = Math.round((iststundenRounded - sollstundenRounded) * 100) / 100
        let gesUeberstunden = ueberstundenRounded + this.state.vormonatUeberstunden;
        istProps.value = iststundenRounded;
        sollProps.value = sollstundenRounded;
        monatUeberProps.value = ueberstundenRounded;
        gesUeberProps.value = gesUeberstunden;

        return <>
            <div style={{ display: "flex" }}>
                <div style={{ alignContent: "center" }}>Gesamt IST</div>
                <FieldInstance noLabel={true} label="Gesamt IST" noHover={true}>
                    <IsNumericTextBox {...istProps} />
                </FieldInstance>
                <div style={{ alignContent: "center" }}>Gesamt SOLL</div>
                <FieldInstance noLabel={true} label="Gesamt SOLL" noHover={true}>
                    <IsNumericTextBox {...sollProps} />
                </FieldInstance>
                <div style={{ alignContent: "center" }}>Überstunden aktueller Monat</div>
                <FieldInstance noLabel={true} label="Überstunden aktueller Monat" noHover={true}>
                    <IsNumericTextBox {...monatUeberProps} />
                </FieldInstance>
                <div style={{ alignContent: "center" }}>Überstunden gesamt</div>
                <FieldInstance noLabel={true} label="Überstunden gesamt" noHover={true}>
                    <IsNumericTextBox {...gesUeberProps} />
                </FieldInstance>

            </div>


        </>
    }

    render() {
        return (<>
            <div style={{ display: "flex", height: "100%", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "column", height: "10%" }}>
                    {this.createFilter()}
                </div>
                <div style={{ display: "flex", flexDirection: "column", height: "10%" }}>
                    {this._renderVormonat()}
                </div>
                <div style={{ display: "flex", flexDirection: "column", maxHeight: "80%", flex: 1 }}>
                    <Menu entries={[
                        { type: EntryType.Save, onClick: () => { this.save(); } },
                        { type: EntryType.Save, onClick: () => { this.loadData(); } }
                    ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={null} />
                    <EditableGrid data={this.state.gridData}
                        id="monatsAbrechnungInGrid"
                        schema={this.schema}
                        gridOptions={this.gridOptions}
                        ref={(ref) => this.editableGridRef = ref}
                        editable={this.props.entity.RecordRight.CanWrite}
                        onDataChanged={this.onGridDataChanged}
                        onRowClicked={(e, dataItem) => {
                            if (Helper.hasValue(this.props.onRowClicked))
                                this.props.onRowClicked(dataItem);
                        }}
                        groupable={false}
                        filterable={false}
                        selectable={false}
                        pageable={false}
                        scrollable={true}
                        showSelectableCheckBox={false}
                        {...this.props}

                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column", height: "10%" }}>
                    {this._renderTotals()}
                </div>
            </div>
            <div>
            </div>

        </>
        );

    }
}

export interface MonatsAbrechnungEintrag {
    PseudoID: string;
    Ressnr: string;
    Jahr: number;
    Monat: number;
    Cmtp_Datum: Date;
    Cmtp_Typ?: number;
    IstArbeitszeit: boolean;
    Faktor?: number
    Cmtp_Beginn?: number;
    Cmtp_Ende?: number;
    Cmtp_PauseMinuten?: number;
    Cmtp_Sonderfall?: number
    Cmtp_10H: boolean;
    Cmtp_Ruhezeit: boolean;
    Cmtp_Kommentar?: string;
    Iststunden?: number;
    Sollstunden?: number;

}
export interface MonatsAbrechnungFileInfo {
    Guid: string;
    Filename: string;
}
export interface MonatsAbrechnungTypLookup {
    Id: number;
    Typname: string;
    Arbeitszeit: boolean;
    Faktor?: number;
}
export interface VormonatsInfo {
    Ueberstunden_Vormonat: number;
    Ueberstunden_Vormonat_Ausgezahlt: number;
}